// validación de formularios
// export default
export const validationRuls = {

    required: (value) => !!value || "Campo Requerido",
    inputReq: (value) => !!value || "Campo Requerido",
    selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
    email: (value) =>
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
      "El correo electrónico es incorrecto",
    min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
    min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
    min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
    max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
    max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
    max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
    max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
    max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
    max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
    max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
    max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
    max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
    max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

    email_null: (value) => {
      if (value == "") {
        return false;
      } else {
        const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
        return pattern.test(value) || "El correo Electrónico es incorrecto";
      }
    },

};
